import { CustomFieldType } from "app/containers/Features/containers/TeamSettings/container/Projects/container/CustomFields/types";
import { TicketField } from "app/containers/Features/containers/TeamSettings/container/Projects/container/WorkItems/types";

import React from "react";
import { fieldRenderers } from "app/containers/Features/containers/Ticket/components/Content/components/Details/components/CustomField/components/FieldRenderers";
import FieldWrapper from "app/containers/Features/containers/Ticket/components/Content/components/Details/components/CustomField/components/FieldWrapper";
import {
  getTicketCustomFieldError,
  getTicketCustomFieldValue,
} from "app/containers/Features/containers/Boards/helpers";
import { ITicketFormData } from "app/containers/Features/containers/Boards/containers/Tickets/types";

type CustomFieldValue = string | number | boolean | Date | string[];

interface Props {
  fields: TicketField;
  form: ITicketFormData;
  onChangeField: (
    fieldId: string,
    value: CustomFieldValue,
    shouldSave?: boolean,
  ) => void;
  isFirst: boolean;
  isLast: boolean;
}

export default function RenderFields({
  fields,
  form,
  onChangeField,
  isFirst,
  isLast,
}: Props) {
  const getValue = (id: string) => getTicketCustomFieldValue(id, form);

  const getError = (id: string) => getTicketCustomFieldError(id, form);

  const renderer = fieldRenderers(
    fields,
    getValue,
    getError,
    onChangeField,
    isFirst,
    isLast,
  )[
    fields.fieldToolTip as CustomFieldType
  ];

  if (!renderer) return null;

  return (
    <FieldWrapper
      field={fields}
      hasError={!!getError(fields._id)}
      isFirst={isFirst}
      isLast={isLast}
    >
      {renderer(fields)}
    </FieldWrapper>
  );
}

